import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.tsx';

import 'unfonts.css';

Sentry.init({
  dsn: 'https://97d076e3836b32135a4741db7041a281@o4509234873499648.ingest.us.sentry.io/4509295398354944',
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENV || 'local',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENV === 'production' ? 0.01 : 0.1,
  tracePropagationTargets: [
    'localhost',
    'https://api.develop.np.hauserhq.com',
    'https://api.app.hauserhq.com',
    'https://api.dashboard.hauserhq.com',
  ],
});

const basename = import.meta.env.BASE_URL;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
